<template>
  <v-card-text class="card-content">
    <slot />
  </v-card-text>
</template>

<script>
export default {};
</script>
